/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WatchdogEventEvent
 */
export interface WatchdogEventEvent {
    /**
     * 
     * @type {string}
     * @memberof WatchdogEventEvent
     */
    datasourcetype?: string;
    /**
     * 
     * @type {number}
     * @memberof WatchdogEventEvent
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof WatchdogEventEvent
     */
    severity?: WatchdogEventEventSeverityEnum;
}


/**
 * @export
 */
export const WatchdogEventEventSeverityEnum = {
    Note: 'note',
    Warning: 'warning',
    Alert: 'alert'
} as const;
export type WatchdogEventEventSeverityEnum = typeof WatchdogEventEventSeverityEnum[keyof typeof WatchdogEventEventSeverityEnum];


/**
 * Check if a given object implements the WatchdogEventEvent interface.
 */
export function instanceOfWatchdogEventEvent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WatchdogEventEventFromJSON(json: any): WatchdogEventEvent {
    return WatchdogEventEventFromJSONTyped(json, false);
}

export function WatchdogEventEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): WatchdogEventEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'datasourcetype': !exists(json, 'datasourcetype') ? undefined : json['datasourcetype'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'severity': !exists(json, 'severity') ? undefined : json['severity'],
    };
}

export function WatchdogEventEventToJSON(value?: WatchdogEventEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'datasourcetype': value.datasourcetype,
        'id': value.id,
        'severity': value.severity,
    };
}

